export class TadInHoursVO {
  id:number;
  date: Date;
  allDay: boolean;
  registrationNumber: string;
  createdBy: string;
  description: string;
  startTime: string;
  endTime: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
  deleted: boolean =false;
  timeZone: number;
}



// WEBPACK FOOTER //
// ./src/app/model/tadInHoursVO.ts